import React from 'react';
import { HiRefresh } from 'react-icons/hi';
import { motion } from 'framer-motion';

export default function RefreshButton({ onClick, className = "" }) {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ rotate: 180 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.3 }}
      className={`p-2.5 rounded-xl bg-white dark:bg-slate-900/50 hover:bg-gray-50 dark:hover:bg-slate-800/70 transition-all duration-200 group shadow-sm hover:shadow-md border border-gray-200 dark:border-slate-700/50 hover:border-orange-500/30 backdrop-blur-sm ${className}`}
      title="Refresh"
      aria-label="Refresh list"
    >
      <HiRefresh className="w-5 h-5 text-gray-600 dark:text-slate-400 group-hover:text-orange-500 dark:group-hover:text-orange-400 transition-colors" />
    </motion.button>
  );
}
